import { Link } from "react-router-dom";
import { formatINR } from "../lib/api";
import { motion } from "framer-motion";

export const ProductFrame = ({ product, index = 0 }) => (
  <motion.div
    data-testid={`product-${product.slug}`}
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.8, delay: (index % 3) * 0.1, ease: [0.16, 1, 0.3, 1] }}
    className="group"
  >
    <Link to={`/product/${product.slug}`}>
      <div className="relative aspect-[3/4] bg-mj-surface border border-mj-border overflow-hidden">
        <div className="absolute inset-0 flex flex-col items-center justify-center transition-transform duration-700 group-hover:scale-105">
          <span className="font-serif-mj text-mj-gold/40 text-8xl leading-none">M</span>
          <span className="overline text-mj-muted/60 mt-4 text-[0.6rem]">Photo coming soon</span>
        </div>
        <div className="absolute top-0 left-0 right-0 h-1.5 bg-gradient-to-r from-transparent via-mj-gold to-transparent opacity-60" />
        <div className="absolute bottom-0 left-0 right-0 h-1.5 bg-gradient-to-r from-transparent via-mj-gold to-transparent opacity-60" />
        <div className="absolute inset-0 bg-mj-red/0 group-hover:bg-mj-red/5 transition-colors duration-500" />
      </div>
      <div className="pt-4 flex justify-between items-baseline">
        <div>
          <p className="overline text-mj-golddeep text-[0.6rem] mb-1">{product.fabric}</p>
          <h3 className="font-serif-mj text-xl text-mj-text leading-tight">{product.name}</h3>
        </div>
        <span className="font-sans-mj text-sm text-mj-muted whitespace-nowrap ml-3">{formatINR(product.price)}</span>
      </div>
    </Link>
  </motion.div>
);
